class ESACustomBlock extends HTMLElement {
  constructor() {
    super();
    this.handleSellingPlanChange = this.handleSellingPlanChange.bind(this);
  }

  connectedCallback() {
    this.giftWrapper = this.querySelector('.esa__gift-options');

    // Find hidden selling plan input (global in product form)
    this.sellingPlanInput = document.querySelector('.selected-selling-plan-id');

    if (!this.sellingPlanInput || !this.giftWrapper) return;

    // Initial state
    this.toggleVisibility();

    // Listen for changes
    this.observeSellingPlan();
  }

  observeSellingPlan() {
    // Listen to change event (if manually triggered)
    this.sellingPlanInput.addEventListener('change', this.handleSellingPlanChange);

    // Also observe value changes (important for Shopify JS updates)
    this.observer = new MutationObserver(() => {
      this.toggleVisibility();
    });

    this.observer.observe(this.sellingPlanInput, {
      attributes: true,
      attributeFilter: ['value']
    });
  }

  handleSellingPlanChange() {
    this.toggleVisibility();
  }

  toggleVisibility() {
    const value = this.sellingPlanInput.value;

    if (value && value !== '') {
      this.giftWrapper.style.display = 'flex';
    } else {
      this.giftWrapper.style.display = 'none';
    }
  }

  disconnectedCallback() {
    if (this.sellingPlanInput) {
      this.sellingPlanInput.removeEventListener('change', this.handleSellingPlanChange);
    }
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}

customElements.define('esa-custom-block', ESACustomBlock);